// import Permission from "../../../../common/components/auth/Permission";
// import SubTablePurchaseOrder from "../tables/SubTablePurchaseOrder";
import { usePurchaseOrderDashboardContext } from "./PurchaseOrder.context";

import './index.scss'
import InfoTablePurchaseOrder from "../tables/InfoTablePurchaseOrder";
import { IPurchaseOrder } from "../../../../types/purchaseOrder.types";
import { useEffect, useState } from "react";

export function PurchaseOrderDashboard() {
  const { purchaseOrder: purchaseOrderContext } = usePurchaseOrderDashboardContext();
  const [purchaseOrder, setPurchaseOrder] = useState<IPurchaseOrder>(purchaseOrderContext)

  useEffect(() => {
    setPurchaseOrder(purchaseOrderContext);
  }, [purchaseOrder, purchaseOrderContext]);

  if (!purchaseOrder) {
    return <div>Loading...</div>;
  }

  return (
    <div className="flex flex-col items-center h-full overflow-y-auto bg-white  text-black  p-2">     
        <InfoTablePurchaseOrder purchaseOrder={purchaseOrder} />
      
    </div>

  )
}